module.exports = __webpack_public_path__ + "img/128.582089d9.jpg";